import React, { useContext } from 'react';

import ImageGallery from '@/common/components/image-gallery/image-gallery.component';
import { type ImageType } from '@/common/types/image.type';
import { ProductContext } from '@/common/contexts/product.context';

interface AllImagesType {
  AllImages: ImageType[];
}
function ProductGallery({ AllImages }: AllImagesType) {
  const { selectedImageIndex, setSelectedImageIndex } =
    useContext(ProductContext);

  return (
    <ImageGallery
      images={AllImages}
      selectedImage={selectedImageIndex}
      setSelectedImage={setSelectedImageIndex}
    />
  );
}

export default ProductGallery;
